import React from 'react';
import { Section, FadeIn } from './ui';
export const BonusesSection = () => {
  const bonuses = [{
    icon: '📝',
    title: '10 Ejercicios Prácticos',
    desc: 'Para trabajar tu proceso con honestidad'
  }, {
    icon: '💬',
    title: 'Scripts Reales',
    desc: 'Palabras exactas para poner límites'
  }, {
    icon: '📋',
    title: 'Checklists de Autocuidado',
    desc: 'Para implementar desde hoy'
  }, {
    icon: '🗺️',
    title: 'Plan de 90 Días',
    desc: 'Tu hoja de ruta personal al cambio'
  }, {
    icon: '📜',
    title: 'Declaración Personal',
    desc: 'Tu compromiso contigo misma'
  }];
  return <Section className="bg-white" data-id="element-36">
      <FadeIn data-id="element-37">
        <div className="text-center mb-6 sm:mb-16" data-id="element-38">
          <h2 className="text-2xl sm:text-4xl font-serif text-navy-900 mb-2 sm:mb-4" data-id="element-39">
            🎁 Además Incluye:
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 sm:gap-6" data-id="element-40">
          {bonuses.map((bonus, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-41">
              <div className="bg-cream-100 rounded-xl sm:rounded-2xl p-4 sm:p-6 h-full border border-cream-200 flex flex-col items-center text-center" data-id="element-42">
                <span className="text-3xl sm:text-4xl mb-2 sm:mb-4" data-id="element-43">
                  {bonus.icon}
                </span>
                <h3 className="text-sm sm:text-xl font-medium text-navy-900 mb-1 sm:mb-2" data-id="element-44">
                  {bonus.title}
                </h3>
                <p className="text-xs sm:text-base text-gray-600" data-id="element-45">
                  {bonus.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </FadeIn>
    </Section>;
};